import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";

import {
  useDeleteFaqCategoryById,
  useFAQCategory,
} from "../../../../../api/inquiries/faq/use-faq-category";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import AddFAQ from "./Section/Add";
import EditFAQ from "./Section/Edit";

const FAQManagementPage = () => {
  const navigate = useNavigate();
  const { data } = useFAQCategory();
  const { mutate: deleteFaqCategory } = useDeleteFaqCategoryById();
  const faqCategoryData = data?.data;

  const handleBack = () => {
    navigate("/bulletin-board");
  };

  const onDeleteCategory = async (id) => {
    deleteFaqCategory(id);
  };

  return (
    <>
      <div>
        <TitlePage title="FAQ > 분류 유형 관리" />
        <div className="my-4 flex justify-end items-center">
          <Button text="목록" onClick={handleBack} />
          <AddFAQ />
        </div>
        <table className="w-full text-center">
          <thead>
            <tr className="border border-[#dddddd] font-bold" key={0}>
              <th className="p-2 bg-[#f2f2f4] font-bold border border-[#dddddd] w-[7rem]">
                번호
              </th>
              <th className="p-2 bg-[#f2f2f4] font-bold border border-[#dddddd] w-[50%]">
                분류 유형 명
              </th>
              <th className="p-2 bg-[#f2f2f4] font-bold border border-[#dddddd] w-[10rem]">
                등록일자
              </th>
              <th className="p-2 bg-[#f2f2f4] font-bold border border-[#dddddd] w-[8rem]">
                공개여부
              </th>
              <th className="p-2 bg-[#f2f2f4] font-bold border border-[#dddddd] w-[8rem]">
                게시물 개수
              </th>
              <th className="p-2 bg-[#f2f2f4] font-bold border border-[#dddddd] w-[8rem]">
                관리
              </th>
            </tr>
          </thead>

          <tbody>
            {faqCategoryData &&
              faqCategoryData?.map((res, index) => {
                return (
                  <tr
                    key={res?.id}
                    className={`${
                      res?.nonDeletable === true ? "bg-[#f7f7f7]" : ""
                    }`}
                  >
                    <td className="py-2 px-3 border border-[#dddddd]">
                      {index + 1}
                    </td>
                    <td className="py-2 px-3 border border-[#dddddd]">
                      {res?.name}
                    </td>
                    <td className="py-2 px-3 border border-[#dddddd]">
                      {dayjs(res?.createdAt).format("YYYY-MM-DD HH:mm")}
                    </td>
                    <td className="py-2 px-3 border border-[#dddddd]">
                      {res?.status === "ON" ? "공개" : "비공개"}
                    </td>
                    <td className="py-2 px-3 border border-[#dddddd]">
                      {res?.faqCount}
                    </td>
                    <td className="py-2 px-8 border border-[#dddddd]">
                      {res?.nonDeletable === true ? null : (
                        <div className="flex justify-center items-center gap-2">
                          <EditFAQ defaultValue={res} />
                          <Modal
                            description={
                              <span>
                                해당 항목을 삭제하시겠습니까? 분류 유형을 삭제
                                할 경우, 등록된 게<br />
                                시물은 ‘분류 미해당’ 으로 자동 분류되며 FAQ에
                                게시글이 비공개(미등록) <br />
                                처리됩니다. 분류 미해당에 분류된 비공개 FAQ
                                게시물을 변경하려면, <br />
                                FAQ 목록화면에서 변경 가능합니다.
                              </span>
                            }
                            onSubmit={() => onDeleteCategory(res?.id)}
                          >
                            <Button
                              bgColor="bg-[#dddddd]"
                              borderColor="border border-[#cccccc]"
                              textColor="text-[#707070]"
                              text="삭제"
                              width="w-12"
                              paddingButton="p-1"
                              margin="mr-0"
                            />
                          </Modal>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default FAQManagementPage;
